import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MedicalItemHelper } from "@/Patient/Helpers/MedicalItemHelper";
import { MedicalItemMedicalReaction } from "@/Patient/Models/MedicalSummary/MedicalItemMedicalReaction";
import { ClickableMedicalReactionItem } from "./ClickableMedicalReactionItem";

import styles from "./MedicalReactionsView.module.scss";

interface IMedicalReactionsViewProps {
    reactions: MedicalItemMedicalReaction[];
    element?: JSX.Element;
    showAllergiesEmptyLabel?: boolean;
    showIntolerancesEmptyLabel?: boolean;
    showReactionsEmptyLabel?: boolean;
}

function MedicalReactionsView({
    reactions,
    element,
    showAllergiesEmptyLabel,
    showIntolerancesEmptyLabel,
    showReactionsEmptyLabel
}: Readonly<IMedicalReactionsViewProps>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.reactionsContainer}>
            <div className={styles.reactionsLabelContainer}>
                <span className={styles.reactionsLabel}>{getText("AllergiesAndIntoleranceLabel")}</span>
                {element}
            </div>
            <div className={styles.reactions}>
                <ClickableMedicalReactionItem
                    allergies={MedicalItemHelper.getMedicalItemFromVisibleAndValidTemplate(reactions) as MedicalItemMedicalReaction[] ?? []}
                    showAllergiesEmptyLabel={showAllergiesEmptyLabel}
                    showIntolerancesEmptyLabel={showIntolerancesEmptyLabel}
                    showReactionsEmptyLabel={showReactionsEmptyLabel}
                    isReadOnly
                />
            </div>
        </div>
    );
}

export { MedicalReactionsView };
